import axios from '../base/axios';
import API_KEY from './key';

const GET_TVAIRINGTODAY = 'flixfrenzy/redux/GET_TVAIRINGTODAY';

// eslint-disable-next-line default-param-last
const tvAiringTodayReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVAIRINGTODAY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvAiringToday = () => (dispatch) => {
  axios.get(`tv/airing_today?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TVAIRINGTODAY,
      payload: res.data,
    });
  });
};

export default tvAiringTodayReducer;
